export const campaignKeys = {
  projects: (accountId) => ['projects', { accountId }] as const,
}
